import React, { useEffect, useState } from 'react';
import { createClient } from '../../../lib/supabase/client';

export default function DashboardStats() {
  const [stats, setStats] = useState({
    totalProjects: 0,
    activeProjects: 0,
    totalRevenue: 0,
    pendingInvoices: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      const supabase = createClient();
      
      const [projectsResult, invoicesResult] = await Promise.all([
        supabase.from('projects').select('id, status'),
        supabase.from('invoices').select('total_amount, status'),
      ]);

      const projects = projectsResult.data || [];
      const invoices = invoicesResult.data || [];

      setStats({
        totalProjects: projects.length,
        activeProjects: projects.filter(p => p.status === 'in_progress').length,
        totalRevenue: invoices
          .filter(i => i.status === 'paid')
          .reduce((sum, i) => sum + (i.total_amount || 0), 0),
        pendingInvoices: invoices.filter(i => i.status === 'sent' || i.status === 'overdue').length,
      });
      setLoading(false);
    };

    fetchStats();
  }, []);

  if (loading) {
    return <div className="text-center py-8">Chargement...</div>;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
        <h3 className="text-sm font-medium text-gray-500">Total Chantiers</h3>
        <p className="text-3xl font-bold text-gray-900 mt-2">{stats.totalProjects}</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
        <h3 className="text-sm font-medium text-gray-500">Chantiers Actifs</h3>
        <p className="text-3xl font-bold text-gray-900 mt-2">{stats.activeProjects}</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
        <h3 className="text-sm font-medium text-gray-500">Chiffre d'affaires</h3>
        <p className="text-3xl font-bold text-gray-900 mt-2">
          {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(stats.totalRevenue)}
        </p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
        <h3 className="text-sm font-medium text-gray-500">Factures en attente</h3>
        <p className="text-3xl font-bold text-gray-900 mt-2">{stats.pendingInvoices}</p>
      </div>
    </div>
  );
}

